import { useCallback } from "react";
import { RootState } from "src/store";
import { useSelector } from "react-redux";
import { Shared_DateFormats, Shared_Languages } from "src/backend/openapi/v1";
import { enumToObject } from "src/utils";

/**
 * useUserSettigs is a custom hook for retrieving the current user's settings.
 *
 * @returns {Object} - An object containing the current user's settings.
 *                    - language - en or da
 *                    - dataFormat - DDMMYYY or any other date formats
 */

const formatDatePattern = (pattern: string) => {
  return pattern.replace(/YYYY/, "YYYY/").replace(/MM/, "MM/").replace(/DD/, "DD/").replace(/\/$/, "");
};

export const useUserSettings = () => {
  let language: "en" | "da" = "en",
    dateFormat;

  const selector = useCallback(
    (state: RootState) => ({
      contactPersonDetails: state.generalReducer.applicationReducer.contactPersonDetails
    }),
    []
  );

  const { contactPersonDetails } = useSelector(selector, (prev, cur) => prev.contactPersonDetails === cur.contactPersonDetails);

  if (contactPersonDetails.loading === "has-loaded") {
    // Language
    switch (contactPersonDetails.data.languageId) {
      case Shared_Languages.English:
        language = "en";
        break;
      case Shared_Languages.Danish:
        language = "da";
        break;
    }

    // Date format
    const dateFormats = enumToObject(Shared_DateFormats);
    const dateFormatKey = Object.keys(dateFormats).find(key => contactPersonDetails.data.dateFormatId === dateFormats[key]);
    if (dateFormatKey) dateFormat = formatDatePattern(dateFormatKey);
  }

  return { dateFormat, language };
};
